// src/pages/Dashboard/utils/numberUtils.js

/**
 * Wrap a value in an array if it isn't already one.
 * Returns an empty array for nullish input.
 */
export const toArray = (data) =>
  Array.isArray(data) ? data : data ? [data] : [];

/**
 * Coerce any value to a finite number, defaulting to 0.
 */
export const safeNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/**
 * Count array length when an array is provided; otherwise treat the
 * incoming value as a numeric count (the backend uses Schema.Types.Mixed
 * for a number of these fields, so they may arrive as either shape).
 */
export const arrCount = (v) => (Array.isArray(v) ? v.length : safeNum(v));

/**
 * Sum a numeric key across a list of records, safely.
 */
export const sumBy = (arr, key) =>
  arr.reduce((sum, item) => sum + safeNum(item?.[key]), 0);

/**
 * Format a date string/Date as e.g. "Mar 2026". Falls back to "Unknown"
 * when the input cannot be parsed.
 */
export const getMonthLabel = (date) => {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "Unknown";
  return d.toLocaleString("default", { month: "short", year: "numeric" });
};
